// extracted by mini-css-extract-plugin
export var active = "_41-7";
export var container = "_41-0";
export var evenWidth = "_41-4";
export var large = "_41-5";
export var outlet = "_41-8";
export var slide = "_41-2";
export var small = "_41-6";
export var tab = "_41-3";
export var tabs = "_41-1";